import React from "react";
import InfoIcon from "../../../Assets/images/icon-info-circle.svg";
import BreachGraph from "../BreachGraph";

const BreachRiskRatingInfo = (props: any) => {
    return (
        <>
            <div className="dialog-header" style={{ display: "flex" }}>
                <div className="dialog-icon status-default" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <img src={InfoIcon} alt="Circle with the letter 'i' in the center, signifying information" />
                </div>
                <div className="box-title-text">
                    <h2 className="box-title breach-dialog-title">Breach Risk Rating</h2>
                </div>
            </div>
            <div className="dialog-body margin-left-s">
                <div className="row">
                    <div className="col-xs-2 col-sm-1"></div>
                    <div className="col-xs-8 col-sm-10">
                        <p className="risk-rating-description">
                            The Breach Risk Rating provides an estimated risk rating for the selected data breach. The rating is based on a 1-10 risk diagnostic
                            scale, 1 being the lowest risk and 10 being the highest risk.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-2 col-sm-1"></div>
                    <div className="col-xs-8 col-sm-10">
                        <BreachGraph />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-2 col-sm-1"></div>
                    <div className="col-xs-8 col-sm-10">
                        <div className="risk-rating-title low-risk-color">Low Risk 1-3</div>
                        <p className="risk-rating-description">
                            Low Risk data breaches include those that pose minor risk of identity theft. The combination of personal data elements exposed present
                            low risk of identity fraud.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-2 col-sm-1"></div>
                    <div className="col-xs-8 col-sm-10">
                        <div className="risk-rating-title moderate-risk-color">Moderate Risk 4-6</div>
                        <p className="risk-rating-description">
                            These breaches often expose data like payment card numbers that can be immediately used in low to moderate impact fraud schemes.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-2 col-sm-1"></div>
                    <div className="col-xs-8 col-sm-10">
                        <div className="risk-rating-title high-risk-color">High Risk 7-10</div>
                        <p className="risk-rating-description">
                            Breaches that expose highly sensitive information expose victims to a high risk that criminals will use that information to open
                            accounts in their name, fraudulently access their existing accounts, or commit other high-impact identity fraud schemes.
                        </p>
                    </div>
                </div>
            </div>
            <div className="dialog-footer">
                <div className="row justify-center">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-primary" onClick={props.closeDialog}>
                            <span className="btn-text">Close</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BreachRiskRatingInfo;
